import React from "react";
import { NavItem, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import moment from "moment";

import ApplicationMenu from "../../../../components/common/ApplicationMenu";
import IntlMessages from "../../../../helpers/IntlMessages";

const InventoryAuditApplicationMenu = ({
  data = [],
  filter,
  onFilterChange,
}) => {
  // Tính toán counts
  const getFilteredCount = (filterFunc) => {
    return data.filter(filterFunc).length;
  };

  // Filter by status
  const countDraft = getFilteredCount((item) => item.status === "draft");
  const countInProgress = getFilteredCount(
    (item) => item.status === "in_progress",
  );
  const countCompleted = getFilteredCount(
    (item) => item.status === "completed",
  );

  // Filter by month
  const getMonthCount = (monthsAgo) => {
    const startOfMonth = moment()
      .subtract(monthsAgo, "months")
      .startOf("month");
    const endOfMonth = moment().subtract(monthsAgo, "months").endOf("month");
    return getFilteredCount((item) => {
      const itemDate = moment(item.createdAt);
      return itemDate.isBetween(startOfMonth, endOfMonth, null, "[]");
    });
  };

  const countThisMonth = getMonthCount(0);
  const countLastMonth = getMonthCount(1);

  // Filter by discrepancy (có chênh lệch)
  const countWithDiscrepancy = getFilteredCount((item) =>
    item.items?.some((i) => i.discrepancy !== 0),
  );

  return (
    <ApplicationMenu>
      <PerfectScrollbar
        options={{ suppressScrollX: true, wheelPropagation: false }}
      >
        <div className="p-4">
          <p className="text-muted text-small">
            <IntlMessages id="menu.stock.status" />
          </p>
          <ul className="list-unstyled mb-4">
            <NavItem
              className={classnames({
                active: !filter || filter.type === "all",
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "all" })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.all" />
                </span>
                <span className="float-right">{data.length}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active:
                  filter &&
                  filter.type === "status" &&
                  filter.value === "draft",
              })}
            >
              <NavLink
                to="#"
                onClick={() =>
                  onFilterChange({ type: "status", value: "draft" })
                }
                location={{}}
                style={{ display: "flex", alignItems: "center" }}
              >
                <i
                  className="simple-icon-doc"
                  style={{ marginRight: "8px", fontSize: "14px" }}
                />
                <span style={{ flex: 1 }}>
                  <IntlMessages id="status.draft" />
                </span>
                <span>{countDraft}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active:
                  filter &&
                  filter.type === "status" &&
                  filter.value === "in_progress",
              })}
            >
              <NavLink
                to="#"
                onClick={() =>
                  onFilterChange({ type: "status", value: "in_progress" })
                }
                location={{}}
                style={{ display: "flex", alignItems: "center" }}
              >
                <i
                  className="simple-icon-clock"
                  style={{ marginRight: "8px", fontSize: "14px" }}
                />
                <span style={{ flex: 1 }}>
                  <IntlMessages id="status.in-progress" />
                </span>
                <span>{countInProgress}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active:
                  filter &&
                  filter.type === "status" &&
                  filter.value === "completed",
              })}
            >
              <NavLink
                to="#"
                onClick={() =>
                  onFilterChange({ type: "status", value: "completed" })
                }
                location={{}}
                style={{ display: "flex", alignItems: "center" }}
              >
                <i
                  className="simple-icon-check"
                  style={{ marginRight: "8px", fontSize: "14px" }}
                />
                <span style={{ flex: 1 }}>
                  <IntlMessages id="status.completed" />
                </span>
                <span>{countCompleted}</span>
              </NavLink>
            </NavItem>
          </ul>

          <p className="text-muted text-small">
            <IntlMessages id="menu.stock.time" />
          </p>
          <ul className="list-unstyled mb-4">
            <NavItem
              className={classnames({
                active: filter && filter.type === "month" && filter.value === 0,
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "month", value: 0 })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.this-month" />
                </span>
                <span className="float-right">{countThisMonth}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active: filter && filter.type === "month" && filter.value === 1,
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "month", value: 1 })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.last-month" />
                </span>
                <span className="float-right">{countLastMonth}</span>
              </NavLink>
            </NavItem>
          </ul>

          <p className="text-muted text-small">
            <IntlMessages id="menu.audit.result" />
          </p>
          <ul className="list-unstyled mb-4">
            <NavItem
              className={classnames({
                active: filter && filter.type === "discrepancy",
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "discrepancy" })}
                location={{}}
                style={{ display: "flex", alignItems: "center" }}
              >
                <i
                  className="simple-icon-exclamation"
                  style={{ marginRight: "8px", fontSize: "14px" }}
                />
                <span style={{ flex: 1 }}>
                  <IntlMessages id="menu.audit.has-discrepancy" />
                </span>
                <span>{countWithDiscrepancy}</span>
              </NavLink>
            </NavItem>
          </ul>
        </div>
      </PerfectScrollbar>
    </ApplicationMenu>
  );
};

export default InventoryAuditApplicationMenu;
